import React from 'react';
import styled from 'styled-components';
import { UnstyledLink } from '../Link';
import { isFieldValid } from '../../utils/validation';
import { RichP1 } from '../Typography';
const SourceLinkContainer = styled(UnstyledLink) `
  flex: 1;
  display: flex;
  justify-content: center;
`;
const SourceLinkText = styled(RichP1) `
  color: ${({ theme }) => theme.secondaryBlue};
  display: inline-block;
`;
export const SourceLink = ({ fields }) => {
    if (!fields || !fields.sourceLabel || !fields.sourceUrl) {
        return null;
    }
    const { sourceUrl, sourceLabel } = fields;
    const { text: ariaLabel } = sourceUrl && sourceUrl.value;
    if (!!(isFieldValid(sourceUrl, 'href') && isFieldValid(sourceLabel))) {
        return (React.createElement(SourceLinkContainer, { field: sourceUrl, ariaLabel: ariaLabel },
            React.createElement(SourceLinkText, { field: sourceLabel })));
    }
    else {
        return null;
    }
};
